import { render, staticRenderFns } from "./addClauseList.vue?vue&type=template&id=0bb33010&"
import script from "./addClauseList.vue?vue&type=script&lang=js&"
export * from "./addClauseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb33010')) {
      api.createRecord('0bb33010', component.options)
    } else {
      api.reload('0bb33010', component.options)
    }
    module.hot.accept("./addClauseList.vue?vue&type=template&id=0bb33010&", function () {
      api.rerender('0bb33010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addClauseList.vue"
export default component.exports